function t(n) {
  return function() {
    return n;
  };
}
var r = t;
export {
  r as default
};
//# sourceMappingURL=constant.js.map
